import Vue from "vue";

import { registerLicense } from "@syncfusion/ej2-base";
// Registering Syncfusion license key
registerLicense(
    "Ngo9BigBOggjHTQxAR8/V1NGaF5cXmdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWXheeXZUQ2ddU01xW0I="
);

import { SchedulePlugin } from "@syncfusion/ej2-vue-schedule";

export function RegisterSyncfusionComponents() {
    Vue.use(SchedulePlugin);
}